export default {
    
    LOAD_BANKACCOUNTS (state, bankaccounts) {
		
        state.items = bankaccounts
    }

    
}
